import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const OekonomiOverblik = () => {
  return (
    <div className="py-16 bg-white">
      <Helmet>
        <title>Økonomioverblik: Få overblik over din økonomi</title>
        <meta name="description" content="Vi hjælper med at lave et økonomioverblik. Økonomioverblik laves med henblik på at komme med forslag til forbedringsmuligheder og besparelser. Se mere her" />
      </Helmet>

      <div className="container mx-auto px-4 max-w-4xl">
        <nav className="text-sm text-slate-500 mb-8 flex items-center space-x-2">
          <Link to="/" className="hover:text-[#b60f00]">Forsiden</Link>
          <span>/</span>
          <span className="text-slate-900 font-medium">Økonomi overblik</span>
        </nav>

        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-10 break-words">Økonomi overblik</h1>

        <div className="prose prose-slate prose-lg max-w-none">
          <p className="text-xl leading-relaxed text-slate-600 mb-8">
            Et økonomisk overblik er fundamentet for sunde økonomiske beslutninger. Vi gennemgår din økonomi for at finde forbedringer og besparelser, der passer til dine planer.
          </p>
          
          <h3 className="text-2xl font-bold text-slate-900 mt-8 mb-4">Hvad får du ud af et overblik?</h3>
          <p>
            Vi ser på alt fra lån og renter til pension og opsparing. Formålet er at optimere din daglige økonomi og sikre, at du har råd til det, du drømmer om – både nu og i fremtiden.
          </p>
          <p>
            Udgangspunktet er dine ønsker og planer. Skal der være plads til nyt tag, orlov eller en tidlig pension? Vi regner på konsekvenserne og giver dig konkrete forslag til handling.
          </p>

          <h3 className="text-2xl font-bold text-slate-900 mt-12 mb-4">Løbende opfølgning</h3>
          <p>
            Livet ændrer sig, og det gør din økonomi også. Vi anbefaler et årligt opfølgningsmøde, hvor vi justerer beregningerne i forhold til ændringer i indkomst, skat eller personlige ønsker.
          </p>

          <div className="mt-12 p-8 bg-slate-900 text-white rounded-3xl text-center">
            <h4 className="text-2xl font-bold mb-4">Klar til at få overblik?</h4>
            <p className="text-slate-300 mb-8">Book et uforpligtende møde og lad os gennemgå din økonomi sammen.</p>
            <Link 
              to="/kontakt-os" 
              className="inline-flex items-center bg-[#b60f00] text-white px-8 py-4 rounded-xl font-bold hover:bg-[#a00d00] transition-all shadow-lg active:scale-95"
            >
              Kontakt os nu
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OekonomiOverblik;
